<template>
  <div v-if="visible" class="password-expire-warning-modal-overlay">
    <el-dialog
      title="密码即将过期提醒"
      :visible.sync="visible"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      width="500px"
      center
    >
      <el-alert
        title="您的密码将在7天内过期，建议您尽快修改密码以确保账户安全！"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 20px;"
      />
      
      <div class="modal-footer">
        <el-button size="medium" @click="close">
          稍后修改
        </el-button>
        <el-button type="primary" size="medium" @click="goToChangePassword">
          立即修改
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPasswordWillExpire, removePasswordWillExpire } from "@/utils/passwordStatus";

export default {
  name: "PasswordExpireWarningModal",
  data() {
    return {
      visible: false
    };
  },
  created() {
    // 检查密码是否即将过期
    this.checkPasswordWillExpire();
    // 监听路由变化，每次路由切换时都检查
    this.$router.afterEach(() => {
      this.checkPasswordWillExpire();
    });
  },
  methods: {
    checkPasswordWillExpire() {
      this.visible = getPasswordWillExpire();
    },
    close() {
      // 关闭弹窗并清除密码即将过期标志
      this.visible = false;
      removePasswordWillExpire();
    },
    goToChangePassword() {
      // 关闭弹窗并清除密码即将过期标志
      this.visible = false;
      removePasswordWillExpire();
      // TODO: 跳转到修改密码页面
      // 目前beishida-pc项目没有专门的修改密码页面，这里可以根据实际情况调整
      this.$message.info("即将跳转到修改密码页面");
    }
  }
};
</script>

<style scoped>
.password-expire-warning-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
</style>